import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDLHLKz6WX94haFJqP8fHUq2Yrkw9Z-Swc",
  authDomain: "chanwaihsuen-me.firebaseapp.com",
  projectId: "chanwaihsuen-me",
  storageBucket: "chanwaihsuen-me.appspot.com",
  messagingSenderId: "1091810864993",
  appId: "1:1091810864993:web:dbf5e955c2e5c2bb5f1f20",
  measurementId: "G-ZTJ1SRC9T2",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAnalytics(app);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
